import { ComponentProps, memo } from 'react'
import { Definition } from '@cargomart/ui'
import { useIsMobile } from 'hooks/media'

interface IProps extends Omit<ComponentProps<typeof Definition>, 'isInline'> {}

export const DefinitionAdaptive = memo(function DefinitionAdaptive({ children, ...rest }: IProps) {
  const isMobile = useIsMobile()

  return (
    <Definition isInline={!isMobile} {...rest}>
      {children}
    </Definition>
  )
})
